import messages, { MessageKey } from '../locales/en';
import { PageRoutes } from './page-routes';
import { PageStore } from './page-store';

export interface Page {
  title: MessageKey;
  subtitle?: MessageKey;
  path: PageRoutes;
  heroImage: string;
  heroImageAlt: MessageKey;
  /**
   * In minutes.
   */
  readingTime: number;
  summary?: React.ReactNode;
  content: React.ReactNode;
  linkedPages?: (store: PageStore) => Page[];
  maxWidth?: boolean;
}

export type PageHierarchyInformation = {
  title: MessageKey;
  path: PageRoutes;
};

export interface PageHierarchyItem extends PageHierarchyInformation {
  children: PageHierarchyInformation[];
}

export const getPageMeta = (page: Page) => {
  return [
    { title: `${messages[page.title]} - camp67` },
    {
      name: 'description',
      content: page.summary,
    },
    {
      tagName: 'link',
      name: 'canonical',
      href: `https://camp67.com${page.path}`,
    },
  ];
};
